import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Loader from "Components/UI/Loader";
import { getLocalStorage } from "Network/ApiService";
import { ls_vars } from "Library/Constants";
import MaterialSelect from "@mui/material/Select";
// Images
import images from "Assets/images";
// css
import "Components/Common/Modal/style.css";
import "Components/Core/BookingFormModule/new-booking-form.css";
import { useApiCall } from "Hooks/useApiCall";
import { MenuItem } from "@mui/material";
import { getFilteredCommonUtils } from "Network/Core/CommonUtils/commonUtils";
import React from "react";
import { CountryUomType } from "Network/Core/CountryUom/types";
import { createCountryUom, updateCountryUom } from "Network/Core/CountryUom/CountryUom";
import SelectFormGroup from "Components/UI/SelectFormGroup";

export interface CounterUomModalProps {
  handleClose?: any;
  existingData: CountryUomType;
  Options: { [key: string]: { label: string; options: any[] } };
}

const CounterUomModal = ({
  handleClose,
  existingData,
  Options,
}: CounterUomModalProps) => {
  const project = getLocalStorage(ls_vars.PROJECT_DATA);
  const region = getLocalStorage(ls_vars.REGION_ID);
  const { t } = useTranslation();
  const { call } = useApiCall();
  const { control, handleSubmit, setValue, getValues, formState: { errors } } = useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (key: string) => (event: any) => {
    const value = event?.target?.value || event;
    setValue(key, value);
  };

  const handleClear = (key: string) => () => {
    setValue(key, '');
  };

  const handleEditData = (existingData: any) => {
    Object.keys(Options).forEach(key => {
      if (existingData[key]?.id) {
        setValue(key, existingData[key].id);
      }
    });
  };

  useEffect(() => {
    if (existingData && existingData.id) {
      handleEditData(existingData)
    }
  }, [existingData]);
  

  const handleCreateCountryUom = async (data: any) => {
    const CountryUom = { ...data, isActive: true };
    call(
      () => createCountryUom(CountryUom, region),
      (response) => {
        setIsLoading(false);
        handleClose();
      },
      { successMessage: "Translation.country_uom_add_success" }
    );
  };

  const handleUpdateCountryUom = async (data: any) => {
    if (!existingData || existingData.id === undefined) {
      console.error("Cannot update Countryuom: Invalid ID");
      return;
    }

    const CountryUom = { ...data, isActive: true };
    const id = existingData.id;
    call(
      () => updateCountryUom(id, CountryUom, region),
      (response) => {
        setIsLoading(false);
        handleClose();
      },
      { successMessage: "Translation.country_uom_edit_success" }
    );
  };
  
  return (
    <>
      {isLoading && <Loader />}
      <div
        className="modal fade  show vc-user-invite"
        id="invite_user_Modal"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-dialog-scrollable ">
          <div className="modal-content">
            <div className="modal-header">
              <div className="invite-user-header">
                <h2 className="text-left">
                  {t(existingData && existingData.id ? "Translation.country_uom_edit" : "Translation.country_uom_add")}
                </h2>
              </div>
              <div className="invite-user-header vc-invite-from-procore-link">
                <Link onClick={handleClose} to="">
                  {t("Translation.close")}
                  <img src={images.modalCloseIcon} alt="" />
                </Link>
              </div>
            </div>
            <div className="modal-body">
              <div className="custom-form ">
                <form
                  onSubmit={handleSubmit(
                    existingData && existingData.id
                      ? handleUpdateCountryUom
                      : handleCreateCountryUom
                  )}
                >
                  <div>
                    {Object.entries(Options).map(([key, config]) => (
                      <SelectFormGroup
                        key={key}
                        required
                        label={config.label}
                        errors={errors}
                        name={key}
                        value={getValues(key)}
                        onClear={handleClear(key)}
                        onChange={handleChange(key)}
                        options={config.options}
                        control={control}
                        rules={{
                          required: {
                            value: true,
                            message: `${config.label} is required`,
                          },
                        }}
                      />
                    ))}
                  
                    <div className="modal-footer">
                      <button type="submit" className="btn theme-btn">
                        {t("Translation.submit")}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CounterUomModal;
